import React from 'react';

import { CtaButton, EmailInput } from '@opendoor/bricks';
import { isNil } from 'lodash';

export interface IAccountEmailFormProps {
  email?: string;
  rememberMe?: boolean;
  loading?: boolean;
  onSubmit: (email: string) => void;
  onChangeRememberMe: (rememberMe: boolean) => void;
}

export interface IAccountEmailFormState {
  email: string;
  hasError: boolean;
  rememberMe: boolean;
}

const NO_OP = () => undefined;

export default class AccountEmailForm extends React.Component<
  IAccountEmailFormProps,
  IAccountEmailFormState
> {
  public static defaultProps: Partial<IAccountEmailFormProps> = {
    email: '',
  };

  public state: IAccountEmailFormState = {
    email: this.props.email,
    hasError: false,
    rememberMe: this.props.rememberMe,
  };

  public onChange = (name: string, value?: string, validFormat?: boolean) => {
    const email = isNil(value) ? '' : value.trim();
    this.setState({ email, hasError: isNil(value) || !validFormat });
  };

  public handleSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const { email, hasError } = this.state;

    if (!hasError) {
      onSubmit(email);
    }
  };

  public handleChangeRememberMe = () => {
    const { onChangeRememberMe } = this.props;
    const { rememberMe } = this.state;

    this.setState({ rememberMe: !rememberMe });
    onChangeRememberMe(!rememberMe);
  };

  public render() {
    const { loading } = this.props;
    const { email, hasError, rememberMe } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="input-section text-left">
          <EmailInput
            title="Email"
            onChange={this.onChange}
            content={email}
            name="email"
            inputName="email"
            placeholder="Email"
            autoComplete="email"
            unboundedWidth={true}
            hasError={hasError}
            autoFocus={true}
            required={true}
          />
          <p className="input-field small-margin-top">
            <input
              checked={rememberMe}
              name="remember-me"
              onChange={this.handleChangeRememberMe}
              type="checkbox"
            />
            <b>Remember Me</b>
          </p>
          <div className="submit-button">
            <CtaButton actionText="Next" loading={loading} onClick={NO_OP} type="submit" />
          </div>
          <p className="text-small text-center">
            <a href="/reset-password/new" target="_self">
              Forgot password?
            </a>
          </p>
        </div>
      </form>
    );
  }
}
